/* ImportSummaryRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const _ = require("lodash");

class ImportSummaryRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("import-summary-gl");
        this._rootElem.component = this._model;
        this._logger = this._model.logger;

        this._titlePanel = document.createElement("h2");
        this._titlePanel.classList.add("summary-title");
        this._summaryPanel = document.createElement("div");
        this._summaryPanel.classList.add("summary");
        this._errorPanel = document.createElement("div");
        this._errorPanel.classList.add("import-errors");
        this._errorLabel = document.createElement("div");
        this._errorLabel.classList.add("error-label");
        this._errorLabel.innerHTML = "Errors:";
        this._errorList = document.createElement("div");
        this._errorList.classList.add("error-list");
        this._errorPanel.appendChild(this._errorList);
        this._fillerPanel = document.createElement("div");
        this._fillerPanel.classList.add("filler");
        this._buttonBar = document.createElement("div");
        this._buttonBar.classList.add("summary-buttons");
        this._okButton = new ButtonControl({
            label: "OK",
            darkTheme: true,
        });

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._okButton.on("UserClick", (this._onOkClick = this._onOkClick.bind(this)));
    }
    _unregisterListeners() {
        this._okButton.removeAllListeners("UserClick");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /* jshint ignore:start */
    async shutdown() {
        this._unregisterListeners();
        await this._okButton.shutdown();
        this._summaryPanel = undefined;
        this._errorPanel = undefined;
    }
    /* jshint ignore:end */

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titlePanel);
                this._rootElem.appendChild(this._summaryPanel);
                this._rootElem.appendChild(this._errorLabel);
                this._rootElem.appendChild(this._errorPanel);
                this._rootElem.appendChild(this._fillerPanel);
                this._rootElem.appendChild(this._buttonBar);
                this._buttonBar.appendChild(this._okButton.renderer.rootElement);
                this._displaySummary();
            }
            resolve();
        });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onOkClick() {
        this._model.sendOk();
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    _setTitle() {
        let title = "Import Completed";
        let firstError = _.get(this.model.importResults.summary, "firstError", "");
        if (firstError) {
            if (firstError.startsWith("ExceededDeviceCount")) {
                title += ": Device license count has been exceeded";
            } else {
                title += ": Errors found";
            }
            this._titlePanel.classList.add("error-title");
        } else {
            this._titlePanel.classList.remove("error-title");
        }
        this._titlePanel.innerHTML = title;
    }

    _displaySummary() {
        this._setTitle();
        while (this._summaryPanel.firstChild) {
            this._summaryPanel.firstChild.remove();
        }
        const {targetCount, successCount, failureCount, planCreateCount} =
            this._model.importResults.summary;
        const {zoneSetToDefault} = this._model.importResults;
        let targetLabel = document.createElement("span");
        targetLabel.innerText = `Total number of records: ${targetCount || 0}`;
        this._summaryPanel.appendChild(targetLabel);

        let successLabel = document.createElement("span");
        successLabel.innerText = `Records successful: ${successCount || 0}`;
        this._summaryPanel.appendChild(successLabel);

        let errorLabel = document.createElement("span");
        errorLabel.innerText = `Records in error: ${failureCount || 0}`;
        this._summaryPanel.appendChild(errorLabel);

        let lineFeed = document.createElement("br");
        this._summaryPanel.appendChild(lineFeed);

        let newDevices = document.createElement("span");
        newDevices.innerText = `New Plans created: ${planCreateCount || 0} \r\n`;
        this._summaryPanel.appendChild(newDevices);

        let lineFeed2 = document.createElement("br");
        this._summaryPanel.appendChild(lineFeed2);

        let newZone = document.createElement("span");
        newZone.innerText = zoneSetToDefault;
        this._summaryPanel.appendChild(newZone);

        while (this._errorList.firstChild) {
            this._errorList.firstChild.remove();
        }
        if (_.isNumber(failureCount) && failureCount > 0) {
            this._errorLabel.classList.remove("hidden");
            this._errorPanel.classList.remove("hidden");
            this._fillerPanel.classList.add("hidden");
            let importResults = this._model.importResults;
            importResults.errorMessages.forEach((msg) => {
                let errorMsg = document.createElement("div");
                errorMsg.innerHTML =
                    msg && typeof msg === "string" ? msg.replaceAll("\n", "<br>") : msg;
                errorMsg.classList.add("error-msg");
                this._errorList.appendChild(errorMsg);
            });
        } else {
            this._errorLabel.classList.add("hidden");
            this._errorPanel.classList.add("hidden");
            this._fillerPanel.classList.remove("hidden");
        }
    }
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = ImportSummaryRenderer;
